/* @flow */
import * as React from "react";
import { connect } from "react-redux";
import { ThemeConsumer } from "styled-components";

import Bar from "./Bar";
import ToolsPopup from "./ToolsPopup";
import SwitchStock from "./SwitchStock";
import { InstrumentsIcon, InstrumentIcon } from "./Icons";
import ToolSet from "./ToolSet";
import GraphicalTools from "./GraphicalTools";
import DealsStats from "./DealsStats";
import ClickOutside from "../common/ClickOutside";

import ToolBelt from "./ToolBelt";

import * as Icons from "../Icons/Tools";

import type { Dispatch } from "../../redux/action";
import type { State as ReduxState } from "../../redux/reducer";

type Settings = $PropertyType<ReduxState, "settings">;

type Props = {
  activeStock: string,
  tabs: Array<string>,
  theme: { [key: string]: string | number },
  tradeTheme: string,
  indicators: $PropertyType<Settings, "indicators">,
  chartType: $PropertyType<Settings, "chartType">,
  lineColor: $PropertyType<Settings, "lineColor">,
  lineThickness: $PropertyType<Settings, "lineThickness">,
  interval: $PropertyType<Settings, "interval">,
  sentiments: $PropertyType<Settings, "sentiments">,
  dispatch: Dispatch
};

type ToggleProps = {
  toggle: () => void
};

let shouldDisableOutsideClick = false;

class Toolbar extends React.Component<Props, {}> {
  render() {
    const { props } = this;

    return (
      <Bar>
        <div>
          <SwitchStock
            value={props.activeStock}
            tabs={props.tabs}
            isOTC={props.isOTC}
            onChange={stock => {
              props.dispatch({
                type: "SET_ACTIVE_STOCK",
                payload: {
                  newStock: stock,
                  activeStock: props.activeStock
                }
              });
            }}
            onNextActiveTab={tab => {
              props.dispatch({ type: "SET_ACTIVE_TAB", payload: tab });
            }}
          />

          <ToolSet
            Icon={InstrumentsIcon}
            instruments={props.instruments}
            onClose={props.onClose}
          >
            {(toolSet: ToggleProps) => (
              <ToolsPopup
                close={toolSet.close}
                onClick={toolSet.toggle}
                instruments={toolSet.instruments}
              />
            )}
          </ToolSet>

          <ToolSet Icon={InstrumentIcon} onClose={props.onClose}>
            {(toolSet: ToggleProps) => (
              <ClickOutside
                onOutsideClick={toolSet.close}
                disabled={shouldDisableOutsideClick}
              >
                <GraphicalTools
                  lockOutsideClick={() => (shouldDisableOutsideClick = true)}
                  unlockOutsideClick={() => (shouldDisableOutsideClick = false)}
                  onClick={toolSet.toggle}
                  graphicalMode={props.graphicalMode}
                  settings={props.settings}
                  stock={props.activeStock}
                  dispatch={props.dispatch}
                />
              </ClickOutside>
            )}
          </ToolSet>

          <ThemeConsumer>
            {theme =>
              process.env.REACT_APP_DEPLOY_TARGET === "irontrade" &&
              props.currency !== "THB" && (
                <ToolBelt
                  value={props.tradeTheme}
                  onClick={theme => {
                    props.dispatch({
                      type: "UPDATE_SETTINGS",
                      payload: {
                        theme
                      }
                    });
                  }}
                  buttons={[
                    {
                      icon: <Icons.ModeDark />,
                      active: theme.mode === "dark",
                      key: "default"
                    },
                    {
                      icon: <Icons.ModeLight />,
                      active: theme.mode === "light",
                      key: "light"
                    }
                  ]}
                />
              )
            }
          </ThemeConsumer>
        </div>

        <DealsStats deals={props.deals} mode={props.mode} />
      </Bar>
    );
  }
}

function mapStateToProps({
  graphicalMode,
  tabs,
  settings,
  remoteTradeSettings,
  stocks,
  profile
}: ReduxState) {
  const activeStock = tabs.tabs[tabs.activeTab];
  return {
    graphicalMode,
    activeStock,
    settings,
    tradeTheme: settings.theme,
    mode: settings.mode,
    tabs: tabs.tabs,
    indicators: settings.indicators,
    chartType: settings.chartType,
    lineColor: settings.lineColor,
    lineThickness: settings.lineThickness,
    interval: settings.interval,
    sentiments: settings.sentiments,
    isOTC:
      stocks != null && stocks[activeStock] != null
        ? stocks[activeStock].otc
        : false,
    currency: profile && profile.currency
  };
}

export default connect(mapStateToProps)(Toolbar);



// WEBPACK FOOTER //
// ./src/components/Toolbar/Toolbar.js